import { createSlice } from "@reduxjs/toolkit";

export const macAlertsArraySlice = createSlice({
    name:"macAlertsArray",
    initialState:{
        orign_macAlerts_array:[]
    },
    reducers:{
        ADD_ALL_MAC_ALERTS_SETTING_ARRAY:(state, action)=>{
            if(action.payload!==null){
                state.orign_macAlerts_array=action.payload
            }
        }
    },

})

export const {
    ADD_ALL_MAC_ALERTS_SETTING_ARRAY
} = macAlertsArraySlice.actions

export default macAlertsArraySlice.reducer